import React from 'react'

export default ({ ...props }) => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <circle cx='16' cy='16' r='15.5' fill='white' stroke='#B7B7B7' />
    <path
      d='M16.5682 22.2657L16.5321 16.5319L22.2659 16.5681C22.5553 16.57 22.817 16.3352 22.8503 16.0431C22.8835 15.7511 22.6742 15.5135 22.384 15.5109L16.5259 15.4746L16.4896 9.61647C16.4877 9.32703 16.2501 9.11773 15.9574 9.15025C15.6646 9.18278 15.4306 9.4437 15.4324 9.73463L15.4686 15.4684L9.73476 15.4323C9.44532 15.4304 9.18362 15.6652 9.15038 15.9572C9.13318 16.1145 9.18527 16.2561 9.28285 16.3537C9.36629 16.4371 9.48343 16.4883 9.6166 16.4895L15.4747 16.5258L15.511 22.3839C15.5114 22.5179 15.5634 22.6342 15.6468 22.7177C15.7444 22.8152 15.886 22.8673 16.0433 22.8501C16.3345 22.8177 16.5701 22.5567 16.5682 22.2657Z'
      fill='#0D0D0D'
    />
  </svg>
)
